export default {
  // PDF Header
  pdfTitle: 'Teklif Talebi (RFQ)',
  rfqNumber: 'RFQ No',
  
  // Sections
  projectInfo: 'Proje Bilgileri',
  vendorInfo: 'Taşeron Bilgileri',
  basicInfo: 'Temel RFQ Bilgileri',
  selectedSections: 'Seçilen Bölümler ve Hizmetler',
  additionalServices: 'Ek Hizmet ve Ürün Talepleri',
  technicalSpecs: 'Teknik Özellikler',
  deliveryInstallation: 'Teslimat ve Kurulum',
  specialNotes: 'Özel Notlar ve Kısıtlamalar',
  vendorProposal: 'Taşeron Teklifi',
  deadlineContact: 'Son Tarih ve İletişim Bilgileri',
  
  // Project Info Fields
  projectName: 'Proje Adı',
  projectLocation: 'Proje Lokasyonu',
  projectType: 'Proje Tipi',
  projectDescription: 'Proje Açıklaması',
  
  // Vendor Info Fields
  vendorName: 'Taşeron Adı',
  vendorCompany: 'Firma',
  vendorEmail: 'E-posta',
  vendorPhone: 'Telefon',
  
  // Basic Info Fields
  status: 'Durum',
  priority: 'Öncelik',
  budget: 'Bütçe',
  currency: 'Para Birimi',
  createdDate: 'Oluşturma Tarihi',
  
  // Status Values
  statusDraft: 'Taslak',
  statusSent: 'Gönderildi',
  statusReceived: 'Alındı',
  statusUnderReview: 'İnceleniyor',
  statusApproved: 'Onaylandı',
  statusRejected: 'Reddedildi',
  
  // Priority Values
  priorityLow: 'Düşük',
  priorityMedium: 'Orta',
  priorityHigh: 'Yüksek',
  priorityUrgent: 'Acil',
  
  // Sections and Services
  section: 'Bölüm',
  services: 'Hizmetler',
  
  // Additional Services
  serviceProduct: 'Hizmet/Ürün',
  quantity: 'Miktar',
  unit: 'Birim',
  specifications: 'Özellikler',
  
  // Technical Specs
  specName: 'Özellik',
  specValue: 'Değer',
  
  // Delivery & Installation
  deliveryAddress: 'Teslimat Adresi',
  deliveryDate: 'Teslimat Tarihi',
  installationRequired: 'Kurulum Gerekli mi?',
  installationNotes: 'Kurulum Notları',
  yes: 'Evet',
  no: 'Hayır',
  
  // Special Notes
  constraints: 'Kısıtlamalar',
  specialRequirements: 'Özel Gereksinimler',
  
  // Vendor Proposal
  proposalAmount: 'Teklif Tutarı',
  proposalNotes: 'Teklif Notları',
  proposalDate: 'Teklif Tarihi',
  
  // Deadline & Contact
  submissionDeadline: 'Son Teslim Tarihi',
  contactPerson: 'Teklif Talebini Yapan Kişi',
  contactEmail: 'E-posta Adresi',
  contactPhone: 'Telefon Numarası',
  
  // Common
  notSpecified: 'Belirtilmemiş',
  noData: 'Veri yok',
  
  // Buttons
  edit: 'Düzenle',
  preview: 'Önizleme',
  downloadPDF: 'PDF İndir',
  generating: 'Oluşturuluyor...',
  
  // Language Selection
  turkish: 'Türkçe',
  english: 'İngilizce',
  selectLanguage: 'Dil Seçin'
};